/* eslint-disable react/jsx-boolean-value */
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';
import BookmarkLessonAction from '../../../../../lessons/lessonactions/BookmarkLessonAction';
import { useTeacherCurriculum } from '../../../context/TeacherCurriculumContextProvider';

const defaultProps = {
  showLabel: false,
  className: '',
};

/**
 * Share Link Lesson Action Container
 */
export default function CurriculumBookmarkAction(p) {
  const { lesson, className, showLabel } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCurriculumDomain } = useTeacherCurriculum();
  const { lessonData } = teacherCurriculumDomain.domainData;

  return (
    <BookmarkLessonAction
      lesson={lesson}
      showLabel={showLabel}
      className={className}
      onSaveSuccess={() => {
        // eslint-disable-next-line no-param-reassign
        lesson.meta.assigned = true;
        // eslint-disable-next-line no-param-reassign
        lesson.meta.archived = false;
        teacherCurriculumDomain.updateLessonData([...lessonData.lessons], [...lessonData.included]);
      }}
    />
  );
}
